/**
* @file 资源管理-司机资源-创建司机
* */
<template>
  <div id="training">

    <!-- 模态框 -->
    <el-dialog :visible.sync="trainingVisible" @close="$refs.formTraining.resetFields()" width="26%"
      :title="trainingTitle">
      <el-form :model="formTraining" :rules="rulesTraining" ref="formTraining" label-position="left" label-width="120px">
        <el-form-item label="机构名称" :prop="mixinUserInfo && mixinUserInfo.organizationType === 1
            ? 'organizationId'
            : ''
          ">
          <el-select v-model="formTraining.organizationId" filterable
            v-if="mixinUserInfo && mixinUserInfo.organizationType === 1">
            <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name">
            </el-option>
          </el-select>
          <span v-else>{{
            organizations && organizations[0] && organizations[0].name
          }}</span>
        </el-form-item>
        <el-form-item label="培训内容" prop="courseName">
          <el-input v-model="formTraining.courseName" maxlength="64">
          </el-input>
        </el-form-item>
        <el-form-item label="请选择培训类型" prop="type" class="white">
          <el-radio v-model="formTraining.type" label="GQ">岗前</el-radio>
          <el-radio v-model="formTraining.type" label="RC">日常</el-radio>
          <el-radio v-model="formTraining.type" label="AQ">安全培训</el-radio>
        </el-form-item>
        <el-form-item label="培训日期" prop="courseDate">
          <el-date-picker v-model="formTraining.courseDate" size="mini" type="date">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="培训开始时间" prop="startTime">
          <el-time-picker v-model="formTraining.startTime" value-format="HH:mm" format="HH:mm" size="mini" type="date">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="培训结束时间" prop="stopTime">
          <el-time-picker v-model="formTraining.stopTime" value-format="HH:mm" format="HH:mm" size="mini" type="date">
          </el-time-picker>
        </el-form-item>
        <el-form-item label="照片" prop="photo" class="custom-form-center">
          <up-img :file.sync="formTraining.photo" width="120" height="80"></up-img>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center;padding-top: 0;position: relative;top: -15px;">
        <el-button type="primary" :loading="loadingTraining" @click="formSave('formTraining')">
          保存
        </el-button>
      </div>
    </el-dialog>
    <el-row class="row-bg" style="margin-bottom: 20px; text-align: right">
      <el-button type="primary" @click="trainingVisible = true;
      trainingTitle = '添加培训信息';
                                                                          ">添加
      </el-button>
      <el-button icon="el-icon-refresh" @click=" getTrainingRows "></el-button>
    </el-row>
    <el-table style="margin-bottom: 20px" border empty-text="暂无数据" v-loading=" loading " :data=" trainingRows ">
      <el-table-column v-for="(          item, index          ) in           trainingColumns          " :key=" index "
        :show-overflow-tooltip=" true " :prop=" item.prop " :label=" item.label ">
      </el-table-column>

      <el-table-column fixed="right" label="培训类型" width="100">
        <template slot-scope="scope">
          {{
          scope.row.type == "GQ"
          ? "岗前"
          : scope.row.type == "RC"
          ? "日常"
          : "安全培训"
          }}
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="照片" width="100">
        <template slot-scope="scope">
          <div>
            <el-button v-if=" scope.row.photo != null && scope.row.photo != '' " @click=" view(scope.row) " type="text"
              size="small">查看
            </el-button>
            <span v-else>-</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <div class="custom-action">
            <el-tooltip content="编辑" placement="top">
              <i class="iconfont icon-compile" @click=" edit(scope.row) "></i>
            </el-tooltip>
            <el-tooltip content="删除" placement="top">
              <i class="iconfont icon-delete" @click=" removeTraining(scope.row) "></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="float: right" @size-change=" sizeChange " @current-change=" pageChange "
      :current-page=" pagination.currentPage " :page-sizes=" [20, 30, 40, 60] " :page-size=" pagination.size "
      layout="total, sizes, jumper,prev, pager, next" :total=" pagination.total ">
    </el-pagination>
    <br /><br />
  </div>
</template>

<script>
export default {
  name: "training",
  data() {
    let startTimeValidate = (rule, value, callback) => {
      let stopTime = this.formTraining.stopTime
        ? this.formTraining.stopTime.replace(":", "")
        : null;
      value = value ? value.replace(":", "") : null;
      if (!value) {
        callback(new Error("开始时间不能为空"));
      } else if (stopTime && stopTime <= value) {
        callback(new Error("不能大于或等于结束时间"));
      } else {
        callback();
      }
    };
    let stopTimeValidate = (rule, value, callback) => {
      let startTime = this.formTraining.startTime
        ? this.formTraining.startTime.replace(":", "")
        : null;
      value = value ? value.replace(":", "") : null;
      if (!value) {
        callback(new Error("结束时间不能为空"));
      } else if (startTime && value <= startTime) {
        callback(new Error("不能小于或等于开始时间"));
      } else {
        callback();
      }
    };

    return {
      trainingTitle: "添加培训信息",
      // 培训计划
      trainingVisible: false,
      formTraining: {
        organizationId: null,
        courseName: null,
        type: null,
        courseDate: null,
        startTime: null,
        stopTime: null,
      },
      rulesTraining: {
        organizationId: [{ required: true, message: "请选择机构名称" }],
        courseName: [{ required: true, message: "请输入培训内容" }],
        type: [{ required: true, message: "请选择培训类型" }],
        courseDate: [{ required: true, message: "请选择培训时间" }],
        startTime: [{ required: true, validator: startTimeValidate }],
        stopTime: [{ required: true, validator: stopTimeValidate }],
      },
      trainingColumns: [
        { prop: "organizationName", label: "培训机构名称" },
        { prop: "courseName", label: "培训内容" },
        { prop: "courseDate", label: "培训课程日期" },
        { prop: "startTime", label: "开始时间" },
        { prop: "stopTime", label: "结束时间" },
      ],
      trainingRows: [],
      pagination: {
        page: 1,
        size: 20,
        total: 0,
      },

      // loading
      loading: false,
      loadingTraining: false,
    };
  },
  methods: {
    // 分页
    sizeChange(size) {
      this.pagination.size = size;
      this.getTrainingRows();
    },
    pageChange(page) {
      this.pagination.page = page;
      this.getTrainingRows();
    },
    /**
     * 点击保存
     */
    async formSave() {
      this.$refs.formTraining.validate((valid) => {
        if (valid) {
          if (this.formTraining.id) {
            this.putTraining();
          } else {
            this.postTraining();
          }
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
        }
      });
    },

    edit(row) {
      this.trainingVisible = true;
      this.trainingTitle = "编辑培训信息";
      this.$nextTick(() => {
        this.formTraining = JSON.parse(JSON.stringify(row));
      });
    },

    /**
     * 培训计划新增
     */
    async postTraining() {
      this.loadingTraining = true;
      let url = "/api/v1/manage/organization/supervise/train";
      let startTime = String(this.formTraining.courseDate).replace(
        "00:00:00",
        this.formTraining.startTime + ":00"
      );
      let stopTime = String(this.formTraining.courseDate).replace(
        "00:00:00",
        this.formTraining.stopTime + ":00"
      );
      let params = this.$utils.deepCopyFn({
        ...this.formTraining,
        courseDate: Date.parse(new Date(this.formTraining.courseDate)),
        startTime: Date.parse(new Date(startTime)),
        stopTime: Date.parse(new Date(stopTime)),
      });
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.trainingVisible = false;
        this.getTrainingRows();
      }
      this.loadingTraining = false;
    },

    /**
     * 培训计划编辑
     */
    async putTraining() {
      this.loadingTraining = true;
      let url = "/api/v1/manage/organization/supervise/train";

      let startTime =
        String(new Date(this.formTraining.courseDate)).substr(0, 16) +
        this.formTraining.startTime +
        String(new Date(this.formTraining.courseDate)).substr(21);
      let stopTime =
        String(new Date(this.formTraining.courseDate)).substr(0, 16) +
        this.formTraining.stopTime +
        String(new Date(this.formTraining.courseDate)).substr(21);

      let params = this.$utils.deepCopyFn({
        ...this.formTraining,
        courseDate: Date.parse(new Date(this.formTraining.courseDate)),
        startTime: Date.parse(new Date(startTime)),
        stopTime: Date.parse(new Date(stopTime)),
      });
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.trainingVisible = false;
        this.getTrainingRows();
      }
      this.loadingTraining = false;
    },

    //删除培训计划
    async removeTraining(row) {
      this.$confirm(
        "删除培训计划后，司机详情中的培训信息也将被删除，确认删除吗？",
        "提示"
      ).then(async () => {
        let insuranceURL =
          "/api/v1/manage/organization/supervise/train/" + row.id;
        let res = await this.$axios.delete(insuranceURL);
        if (res && res.code === 1) {
          this.$message.success("已删除");
          this.getTrainingRows();
        }
      });
    },

    //获取培训计划列表
    async getTrainingRows() {
      this.loading = true;
      let params = this.$utils.deepCopyFn(this.pagination);
      let trainingURL = "/api/v1/manage/organization/supervise/train";
      let res = await this.$axios.get(trainingURL, params);
      if (res && res.code === 1) {
        res.data.forEach((item) => {
          item.courseDate = this.$utils.timeFn(item.courseDate, "YYYY/MM/DD");
          item.startTime = this.$utils.timeFn(
            item.startTime,
            "YYYY/MM/DD HH:mm:SS"
          );
          item.stopTime = this.$utils.timeFn(
            item.stopTime,
            "YYYY/MM/DD HH:mm:SS"
          );
          item.startTime = item.startTime.substring(11, 16);
          item.stopTime = item.stopTime.substring(11, 16);
        });
        this.trainingRows = res.data || [];
        this.pagination.total = res.total;
      }
      this.loading = false;
    },

    async view(row) {
      this.$utils.largeImgFn(row.photo)
    },
  },
  async created() {
    this.getTrainingRows();
    await this.mixinOrganizations();
    if (
      !this.id &&
      this.mixinUserInfo &&
      this.mixinUserInfo.organizationType === 2
    ) {
      if (
        this.organizations &&
        this.organizations[0] &&
        this.organizations[0].id
      ) {
        this.$set(
          this.formTraining,
          "organizationId",
          this.organizations[0].id
        );
      }
    }
  },
  watch: {},
};
</script>
<style  lang="less" scoped>
#training {
  /deep/.el-dialog__header {
    padding-left: 40px;
  }

  /deep/.el-dialog__body {
    padding: 0 40px 20px 40px;
  }
}
</style>